/**
 * The theme's `easeOutCubic` timing-function token as a cubic-bezier tuple for
 * motion/react's `ease` prop. The token itself only exists as a CSS string
 * (`cubic-bezier(0.215, 0.61, 0.355, 1)`), which motion can't consume — use
 * this instead of re-inlining the numbers.
 */
export const EASE_OUT_CUBIC = [0.215, 0.61, 0.355, 1] as const;
